import React from 'react';
import FeedbackListElement from './FeedbackListElement.js';

const SchematronListElement = ({ errorData }) => {
    return (
        <FeedbackListElement
            testType={null}
            impactAttribute="schematron"
            testName={errorData.rule_id}
            result={0}
            issueMessage={null}
            failureMode={errorData.rule_text}
            overriddenStatus={false}
        >
            <div className="element-value" style={{ color: '#e83838' }}>
                Warning
            </div>
        </FeedbackListElement>
    );
};

export default SchematronListElement; 